import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import AddItem from '../../../shared/TechSkills/AddItem';
import Item from '../../../shared/TechSkills/Item';
import DragNDropList from '../../../shared/DragNDropList';
import config from '../../../config';

const DevelpmentTechnologiesTab = ({ data, onChange }) => {
  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');

  useEffect(() => {
    if (!('developmentTechnologies' in data)) {
      dispatch({
        type: 'migrate_section',
        payload: {
          key: 'developmentTechnologies',
          value: {
            enable: false,
            heading: 'Development Technologies',
            items: [],
          },
        },
      });
    }
  }, [data, dispatch]);

  return (
    'developmentTechnologies' in data && (
      <>
        <div className="mb23 flex justify-between items-center">
          <div className="title_tab">{t('developmentTechnologies.title.label')}</div>

          <div className="col-span-1">
            <Checkbox
              checked={data.developmentTechnologies.enable}
              onChange={v => onChange('data.developmentTechnologies.enable', v)}
            />
          </div>
        </div>

        <hr className="my-6" />

        <DragNDropList
          data={data}
          dispatch={dispatch}
          onChange={onChange}
          type="developmentTechnologies"
        >
          {data.developmentTechnologies.items.map((x, index) => (
            <Item
              item={x}
              key={x.id}
              index={index}
              onChange={onChange}
              dispatch={dispatch}
              first={index === 0}
              last={index === data.developmentTechnologies.items.length - 1}
              type='developmentTechnologies'
              idTab={config.TECH_SKILLS_TABS.developmentTechnologies}
            />
          ))}        
        </DragNDropList>


        <AddItem heading={data.developmentTechnologies.heading} dispatch={dispatch} type='developmentTechnologies' idTab={config.TECH_SKILLS_TABS.developmentTechnologies} />
      </>
    )
  );
};

export default DevelpmentTechnologiesTab;
